import React, { useEffect, useState } from 'react'
import { getTaxesWithPage } from "../../services/serviceTax";
import { Button, Card, Table } from "antd";
import TaxActions from "./TaxActions";
import TaxCreate from "./TaxCreate";

const Tax = () => {
    const [sortedList, setSortedList] = useState([]);
    const [newModal, setNewModal] = useState(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0
    });

    useEffect(() => {
        getTaxes(pagination.current, pagination.pageSize);
    }, [pagination.current, pagination.pageSize])

    const getTaxes = (page, pageSize) => {
        getTaxesWithPage(page - 1, pageSize)
            .then(({ data }) => {
                handlers.sortData(data.content);
                setPagination({
                    ...pagination,
                    total: data.totalElements,
                })
            })
    };

    const handlers = {
        updater() {
            getTaxes(1, 10);
        },
        modalCloser() {
            setNewModal(!newModal)
        },
        sortData(list) {
            let sorted = []
            list.forEach(item => {
                let pushObj = {
                    key: item.id,
                    id: item.id,
                    taxName: item.name,
                    taxCode: item.code,
                    taxRatio: item.ratio,
                    taxDescription: item.description
                }
                sorted.push(pushObj)
            })
            setSortedList(sorted)
        }
    };

    const handlePaginationChange = (pageNumber, pageSize) => {
        setPagination({
            ...pagination,
            current: pageNumber,
            pageSize: pageSize
        });
    };

    const columns = [
        {
            title: 'Adı',
            dataIndex: 'taxName',
            key: 'taxName'
        },
        {
            title: 'Kodu',
            dataIndex: 'taxCode',
            key: 'taxCode'
        },
        {
            title: 'Oranı',
            dataIndex: 'taxRatio',
            key: 'taxRatio'
        },
        {
            title: 'İşlemler',
            key: 'action',
            render: (text, record) => <TaxActions record={record} updater={handlers.updater} />
        }
    ];

    return (
        <React.Fragment>
            <Card title={'Vergi Listesi'} extra={<Button onClick={() => setNewModal(!newModal)} type={'primary'}> Yeni Ekle </Button>}>
                <Table
                    columns={columns}
                    dataSource={sortedList}
                    pagination={{
                        ...pagination,
                        showSizeChanger: true,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                        onChange: handlePaginationChange,
                    }}
                />
            </Card>

            {newModal ? <TaxCreate show={newModal} modalCloser={handlers.modalCloser} updater={handlers.updater} /> : null}

        </React.Fragment>
    )
}
export default Tax